import { PedidoState } from './pedidoTypes';
import { createReducer } from '@reduxjs/toolkit';
import {
  setPedidoAction,
  cleanPedidoAction,
  addProdutoPedidoAction,
  setEnderecoAction,
  setObservacaoAction,
  delProdutoPedidoAction,
  editProdutoPedidoAction,
  setCupomAction,
  addProdutoCompostoPedidoAction,
  delProdutoCompostoPedidoAction
} from './pedidoActions';
import Pedido, { criarPedido } from '../../shared/entity/Pedido';
import { serialize } from '../../helper';
import ProdutoNoPedido from '../../shared/entity/ProdutoNoPedido';
import ProdutoCompostoNoPedido from '../../shared/entity/ProdutoCompostoNoPedido';

export const initialState: PedidoState = criarPedido();

const pedidoReducer = createReducer(initialState, {
  [setPedidoAction.toString()]: (state, action) => {
    if (setPedidoAction.match(action)) {
      return { ...state, ...action.payload };
    }
  },
  [addProdutoPedidoAction.toString()]: (state, action) => {
    if (addProdutoPedidoAction.match(action)) {
      const novoProduto = serialize<ProdutoNoPedido>(action.payload);
      const newState = { ...state };

      if (!novoProduto.perguntasNoPedido || novoProduto.perguntasNoPedido.length === 0) {
        for (let i = 0; i < newState.produtosNoPedido.length; i++) {
          const produtoNoPedido = newState.produtosNoPedido[i];
          if (
            produtoNoPedido.produtoId === novoProduto.produtoId &&
            novoProduto.tamanhoSelecionado.descricao ===
              produtoNoPedido.tamanhoSelecionado.descricao &&
            novoProduto.tamanhoSelecionado.preco === produtoNoPedido.tamanhoSelecionado.preco &&
            novoProduto.observacao === produtoNoPedido.observacao
          ) {
            newState.produtosNoPedido[i].quantidadeNoPedido += novoProduto.quantidadeNoPedido;
            return;
          }
        }
      }

      newState.produtosNoPedido = [...newState.produtosNoPedido, novoProduto];
      return serialize<Pedido>({ ...newState });
    }
  },
  [editProdutoPedidoAction.toString()]: (state, action) => {
    if (editProdutoPedidoAction.match(action)) {
      const index = action.payload.index;
      const produto = action.payload.produto;
      if (state.produtosNoPedido && state.produtosNoPedido.length > index) {
        state.produtosNoPedido[index] = produto;
      }
    }
  },
  [delProdutoPedidoAction.toString()]: (state, action) => {
    if (delProdutoPedidoAction.match(action)) {
      const index = action.payload;
      state.produtosNoPedido.splice(index, 1);
    }
  },
  [setEnderecoAction.toString()]: (state, action) => {
    if (setEnderecoAction.match(action)) {
      return { ...state, endereco: action.payload };
    }
  },
  [setObservacaoAction.toString()]: (state, action) => {
    if (setObservacaoAction.match(action)) {
      return { ...state, observacao: action.payload };
    }
  },
  [setCupomAction.toString()]: (state, action) => {
    if (setCupomAction.match(action)) {
      return { ...state, cupom: action.payload };
    }
  },
  [cleanPedidoAction.toString()]: (state, action) => {
    return criarPedido();
  },

  [addProdutoCompostoPedidoAction.toString()]: (state, action) => {
    if (addProdutoCompostoPedidoAction.match(action)) {
      const produto = serialize<ProdutoCompostoNoPedido>(action.payload);
      const newState = { ...state };

      newState.produtosCompostosNoPedido = [...newState.produtosCompostosNoPedido, produto];
      return serialize<Pedido>({ ...newState });
    }
  },
  [delProdutoCompostoPedidoAction.toString()]: (state, action) => {
    if (delProdutoCompostoPedidoAction.match(action)) {
      const index = action.payload;
      state.produtosCompostosNoPedido.splice(index, 1);
    }
  }
});

export default pedidoReducer;
